import { Link } from 'react-router-dom';

export const TagCloud = ({ tags }: { tags: string[] }) => (
  <div className="tag-cloud">
    {tags.map((tag) => (
      <Link key={tag} className="tag-cloud__item" to={`/tags/${tag.toLowerCase()}`}>
        #{tag}
      </Link>
    ))}
  </div>
);
